import { ThemeDefault } from './theme-default';
import { Theme2 } from './theme-2';
var angularJsThemes = { ThemeDefault: ThemeDefault, Theme2: Theme2 };
export default angularJsThemes;
